import { SyncManager } from 'db';
import { useIsOnline } from 'hooks';
import { useFormVehicleId } from 'pages/ListerVehicleUploadV2/hooks/useFormVehicleId';
import { useField } from 'react-final-form';
import toast from 'react-hot-toast';
import { UploadStatus, useVideoUploadStatus } from 'services/listerUploadVehicle/v2';

export const useVideoUpload = (sectionId: string) => {
  const vehicleId = useFormVehicleId();

  const isOnline = useIsOnline();

  const {
    input: { value: serverId }
  } = useField(`${sectionId}.id`);

  const { input: videoInput } = useField(`${sectionId}.video`);

  return async (video: Blob[]) => {
    if (!vehicleId) return;
    const syncManager = SyncManager.getInstance(vehicleId);
    await syncManager.queueVideoUpload(serverId, video);
    videoInput.onChange(video);
  };
};
